<div class="modal-header">
    <h5 class="modal-title"><i class="{{opcoes.icone}}"></i><span class="modal-title-text">{{opcoes.titulo}}</span></h5>
    <button type="button" class="close" aria-label="Close" (click)="nao()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>{{ opcoes.mensagem }}</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="sim()">Sim</button>
    <button type="button" class="btn btn-secondary" (click)="nao()">Não</button>
</div>